var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"size":_vm.size,"placeholder":_vm.placeholder},on:{"visible-change":_vm.visiblechange,"change":_vm.change}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.houseTypeId,attrs:{"label":item.houseTypeName,"value":item.houseTypeId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }